import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=ff67f000&scoped=true"
import script from "./indexTwo.vue?vue&type=script&lang=js"
export * from "./indexTwo.vue?vue&type=script&lang=js"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=ff67f000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff67f000",
  null
  
)

export default component.exports